import type {
  LocalizedString,
  LocalizedStringArray,
  LocalizedStringArrayInput,
  LocalizedStringInput,
} from '../../types/product';

/**
 * Normaliza uma string localizada garantindo valores padrão para idiomas vazios
 */
export function normalizeLocalizedString(input: LocalizedStringInput | undefined): LocalizedString {
  return {
    'pt-BR': input?.['pt-BR'] || '',
    'en-US': input?.['en-US'] || '',
    'es-ES': input?.['es-ES'] || '',
  };
}

/**
 * Normaliza um array de strings localizado garantindo valores padrão
 */
export function normalizeLocalizedStringArray(
  input: LocalizedStringArrayInput | undefined
): LocalizedStringArray {
  return {
    'pt-BR': input?.['pt-BR'] || [],
    'en-US': input?.['en-US'] || [],
    'es-ES': input?.['es-ES'] || [],
  };
}

/**
 * Extrai mensagem de erro de forma segura de objetos de erro do react-hook-form
 */
export function getErrorMessage(error: unknown): string | undefined {
  if (!error) return undefined;
  if (typeof error === 'string') return error;
  if (typeof error === 'object' && error !== null) {
    if ('message' in error && typeof (error as { message: unknown }).message === 'string') {
      return (error as { message: string }).message;
    }
    if ('root' in error && typeof error.root === 'object' && error.root !== null) {
      const root = error.root as { message?: unknown };
      if (typeof root.message === 'string') return root.message;
    }
  }
  return undefined;
}

/**
 * Converte erros do react-hook-form para o formato de erro localizado
 */
export function getLocalizedError(
  error: unknown
): { 'pt-BR'?: string; 'en-US'?: string; 'es-ES'?: string } | undefined {
  if (!error || typeof error !== 'object') return undefined;
  const result: { 'pt-BR'?: string; 'en-US'?: string; 'es-ES'?: string } = {};
  const err = error as Record<string, unknown>;

  for (const lang of ['pt-BR', 'en-US', 'es-ES'] as const) {
    if (err[lang] && typeof err[lang] === 'object') {
      const langErr = err[lang] as { message?: string };
      if (langErr.message) result[lang] = langErr.message;
    }
  }

  return Object.keys(result).length > 0 ? result : undefined;
}

/**
 * Valor padrão vazio para LocalizedString
 */
export const emptyLocalizedString: LocalizedString = {
  'pt-BR': '',
  'en-US': '',
  'es-ES': '',
};

/**
 * Valor padrão vazio para LocalizedStringArray
 */
export const emptyLocalizedStringArray: LocalizedStringArray = {
  'pt-BR': [],
  'en-US': [],
  'es-ES': [],
};
